var _defs, _circle, _g, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolanaCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Solana") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "solGrad",
    x1: 0,
    y1: 0,
    x2: 16,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14F195"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#0B0B12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#solGrad)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "3.2,5.0 12.8,5.0 11.4,6.3 1.8,6.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.6,7.35 14.2,7.35 12.8,8.65 3.2,8.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.2,9.7 12.8,9.7 11.4,11.0 1.8,11.0"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaCircle);
export default __webpack_public_path__ + "static/media/solana-circle.6a4e57218930703f78c05cd4fbea4123.svg";
export { ForwardRef as ReactComponent };